// B10's one hotspot-key builder (CAPTURE.md H1; debt 7): every key a B10 screen builds from data goes through it, so a
// stored code such as `reason_lists` or an id such as `R-1040` becomes a capture-grammar segment (`reason-lists`,
// `r-1040`) and never a key the capture harness refuses. Pure: no React.

/** A hotspot key in the capture grammar (lowercase, digits and hyphens, dot-separated): `dash.signals.r-1040`. */
export function hsKey(...parts: readonly (string | number)[]): string {
  return parts
    .flatMap((part) => String(part).split("."))
    .map((segment) => segment.toLowerCase().replace(/[^a-z0-9-]+/g, "-").replace(/^-+|-+$/g, ""))
    .filter(Boolean)
    .join(".");
}
